export const eventSectionItemWidth = {
    base: '100%',
    md: '350px',
    lg: '390px',
    xl: '390px'
}
